const DEFAULT_PAGE_SIZE = 10;

export const calculatePageSize = (value) => {
  const integerValue = parseInt(value);
  const isValid = [10, 25, 50, 100].includes(integerValue);
  return isValid ? integerValue : DEFAULT_PAGE_SIZE;
};
